import React from 'react'
import { Heading, Icon } from '@brainstud/react-tbl/themes/pgw/v1/components/library'
import './Faq.css'

const Faq = props => {
  return (
      <div className={"Faq"}>
        {props.children}
      </div>
  )
}

class FaqItem extends React.Component {
  state = {
    showItem: false
  }

  handleClick = e => {
    this.setState(prevState => {
      return {
        showItem: !prevState.showItem
      }
    })
  }

  render () {
    const classNames = ['Faq-heading']

    if (this.state.showItem) classNames.push('active')

    return (
      <div className={"Faq-item"}>
        <div className={classNames.join(' ')} onClick={this.handleClick}>
          <Heading h3>
            {this.props.title}
            <Icon name={"arrow-up"} size={"large"}></Icon>
          </Heading>
        </div>

        {this.state.showItem &&
        <div className={"Faq-description"}>
          {this.props.children}
        </div>
        }
      </div>
    )
  }

}

export default Faq
export {
  FaqItem
}